const STORAGE_KEY = 'read_notification_ids';

export const getReadNotificationIds = (): number[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const markNotificationAsRead = (id: number): number[] => {
  try {
    const current = getReadNotificationIds();
    if (!current.includes(id)) {
      const updated = [...current, id];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    }
    return current;
  } catch {
    return [];
  }
};

export const markAllNotificationsAsRead = (ids: number[]): number[] => {
  try {
    const current = getReadNotificationIds();
    const set = new Set([...current, ...ids]);
    const updated = Array.from(set);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    return updated;
  } catch {
    return [];
  }
};

export const markNotificationAsUnread = (id: number): number[] => {
  try {
    const current = getReadNotificationIds();
    const updated = current.filter((item) => item !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    return updated;
  } catch {
    return [];
  }
};
